import { Outlet } from 'react-router-dom'
import { BottomNav } from './BottomNav'

/**
 * Layout - Responsive App Shell
 * 
 * Mobile-first design with progressive tablet/desktop enhancements.
 * 
 * Mobile (< 768px):
 * - Content constrained to max-w-md (~448px)
 * - BottomNav visible at bottom
 * - TopBar shows back button
 * 
 * Tablet (768px - 1023px):
 * - Content expands to max-w-4xl (~896px)
 * - BottomNav hidden (md:hidden)
 * - TopBar shows desktop nav links
 * 
 * Desktop (≥ 1024px):
 * - Content expands to max-w-7xl (~1280px)
 * - Full-width TopBar with proper spacing
 * - Navigation through TopBar
 * 
 * Full-screen flows (login, onboarding, camera, QR) render outside this Layout.
 */
export default function Layout() {
  return (
    <div className="min-h-screen bg-oro-bg text-text-primary">
      {/* Full-width responsive container */}
      <div className="relative w-full flex flex-col min-h-screen bg-oro-bg">
        {/* Main content area with constrained inner wrapper */}
        <main className="flex-1 overflow-y-auto pb-20 md:pb-0">
          {/* Responsive content wrapper: mobile (~448px), tablet (~896px), desktop (~1280px) */}
          <div className="w-full max-w-md md:max-w-4xl lg:max-w-7xl mx-auto px-4 md:px-6">
            <Outlet />
          </div>
        </main>
        
        {/* Bottom navigation - hidden on desktop */}
        <BottomNav />
      </div>
    </div>
  )
}
